export default (node) => {
  const dynamicWrapper = node.querySelector('[data-dynamic-menu-wrapper]');
  const dynamicParents = node.querySelectorAll('[data-dynamic-menu-parent]');
  const dynamicChildren = node.querySelectorAll('[data-dynamic-menu-child]');

  const init = () => {
    dynamicParents.forEach((parentLink) => {
      parentLink.addEventListener('mouseenter', () => {
        const parentLinkKey = parentLink.dataset.dynamicMenuParent;
        dynamicParents.forEach((otherParent) => {
          otherParent.classList.remove('opacity-50');
        });
        dynamicParents.forEach((otherParent) => {
          if (otherParent !== parentLink) {
            otherParent.classList.add('opacity-50');
          }
        });
        dynamicChildren.forEach((dynamicChild) => {
          dynamicChild.classList.remove('animate-slide-right');
          dynamicChild.classList.add('animate-slide-left');
        });

        const childMenu = node.querySelector(
          `[data-dynamic-menu-child="${parentLinkKey}"]`
        );
        setTimeout(() => {
          dynamicChildren.forEach((dynamicChild) => {
            if (dynamicChild !== childMenu) {
              dynamicChild.classList.add('hidden');
            }
          });
          childMenu.classList.remove('hidden');
          childMenu.classList.remove('animate-slide-left');
          childMenu.classList.add('animate-slide-right');
        }, 300);
      });
    });
    dynamicWrapper.addEventListener('mouseleave', () => {
      dynamicParents.forEach((parentLink) => {
        parentLink.classList.remove('opacity-50');
      });
      dynamicChildren.forEach((dynamicChild) => {
        dynamicChild.classList.remove('animate-slide-right');
        dynamicChild.classList.add('animate-slide-left');
      });
    });
  };

  init();
};
